<ng-container>
  <button mat-menu-item
    class="menu-invite-user"
    (click)="inviteUsers()"
    >
    <span translate="course-menu_invite-org-users"></span>
  </button>
  <button mat-menu-item
    class="menu-manage-user"
    (click)="manageUsers()">
    <span translate="course-menu_manage-org-users"></span>
  </button>
  <button mat-menu-item
    class="menu-edit"
    (click)="editOrg()">
    <span translate="course-menu_edit-org"></span>
  </button>
  @if (userService.currentUser.is_root_owner) {
    <button mat-menu-item
      (click)="deleteOrg()"
      class="delete-org-btn">
      <span translate="course-menu_delete-org"></span>
    </button>
  }
</ng-container>
